export default __webpack_public_path__ + "static/media/des8.4fea1874.jpeg";